import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'


export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  { path: '/unsubscribe', component: () => import('@/views/unsubscribe'), hidden: true },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: 'Home', icon: 'home' }
    }]
  }
]
export const asyncRouterMap = [
  //订单管理
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: 'Order', icon: 'order' },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: { title: 'Order', icon: 'product-list' }
      }, {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: { title: '订单详情' },
        hidden: true
      },
      {
        path: 'order_receive',
        name: 'order_receive',
        component: () => import('@/views/oms/order/order_receive'),
        meta: { title: 'Receive', icon: 'order-pending' }
      }
      ,
      {
        path: 'order_packing',
        name: 'order_packing',
        component: () => import('@/views/oms/order/order_packing'),
        meta: { title: 'Packing', icon: 'packing' }
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: { title: '退款申请处理', icon: 'refund' }
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: { title: '退款原因详情' },
        hidden: true
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: { title: '退货原因设置', icon: 'order-return-reason' }
      }
      , {
        path: 'au_post',
        name: 'au_post',
        component: () => import('@/views/oms/order/au_post'),
        meta: { title: 'AU-POST', icon: 'tracking' }
      }
      ,
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: { title: '发货列表' },
        hidden: true
      },
      {
        path: 'reminder',
        name: 'reminder',
        component: () => import('@/views/oms/reminder/index'),
        meta: { title: '提醒事项', icon: 'reminder' }
      }
      , {
        path: 'au_post_return',
        name: 'au_post_return',
        component: () => import('@/views/oms/return/index'),
        meta: { title: '退货单号列表', icon: 'return-list' }
      }, {
        path: 'dropShippingProcess',
        name: 'dropShippingProcess',
        component: () => import('@/views/oms/dropShipping/index'),
        meta: { title: 'DropShipping进程', icon: 'processList' }
      }
      , {
        path: 'createOrder',
        name: 'createOrder',
        component: () => import('@/views/oms/create/index'),
        meta: { title: '创建订单', icon: 'product-add' }
      }, {
        path: 'trackingHistoryList',
        name: 'trackingHistoryList',
        component: () => import('@/views/oms/order/trackingHistoryList'),
        meta: { title: '发货历史', icon: 'product-list' }
      }
    ]
  }
  ,
  //商品管理
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '商品', icon: 'product' },
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: { title: '商品列表', icon: 'product-list' }
    }
      , {
      path: 'productDetailInfo',
      name: 'productDetailInfo',
      component: () => import('@/views/pms/product/productDetailInfo'),
      meta: { title: '商品详情' },
      hidden: true
    },
    {
      path: 'addProduct',
      name: 'addProduct',
      component: () => import('@/views/pms/product/add'),
      meta: { title: '添加商品', icon: 'product-add' }
    },
    {
      path: 'updateProduct',
      name: 'updateProduct',
      component: () => import('@/views/pms/product/update'),
      meta: { title: '修改商品', icon: 'product-add' },
      hidden: true
    },
    {
      path: 'publishProduct',
      name: 'publishProduct',
      component: () => import('@/views/pms/publish/index'),
      meta: { title: '上架商品', icon: 'publish' },
      hidden: true
    },
    {
      path: 'productStockList',
      name: 'productStockList',
      component: () => import('@/views/pms/stock/index'),
      meta: { title: '库存列表', icon: 'product-list' }
    },

    {
      path: 'productStockHistory',
      name: 'productStockHistory',
      component: () => import('@/views/pms/stock/stockHistory'),
      meta: { title: '库存历史', icon: 'history-record' },
      hidden: true
    },
    {
      path: 'productCate',
      name: 'productCate',
      component: () => import('@/views/pms/productCate/index'),
      meta: { title: '商品分类', icon: 'product-cate' }
    },
    {
      path: 'addProductCate',
      name: 'addProductCate',
      component: () => import('@/views/pms/productCate/add'),
      meta: { title: '添加商品分类' },
      hidden: true
    },
    {
      path: 'updateProductCate',
      name: 'updateProductCate',
      component: () => import('@/views/pms/productCate/update'),
      meta: { title: '修改商品分类' },
      hidden: true
    },
    {
      path: 'supplier',
      name: 'supplier',
      component: () => import('@/views/pms/supplier/index'),
      meta: { title: '供应商管理', icon: 'product-brand' }
    },
    {
      path: 'addSupplier',
      name: 'addSupplier',
      component: () => import('@/views/pms/Supplier/add'),
      meta: { title: '添加供应商' },
      hidden: true
    },
    {
      path: 'updateSupplier',
      name: 'updateSupplier',
      component: () => import('@/views/pms/Supplier/update'),
      meta: { title: '编辑供应商' },
      hidden: true
    },
    {
      path: 'tempUpdate',
      name: 'tempUpdate',
      component: () => import('@/views/pms/product/tempUpdate'),
      meta: { title: '临时修改商品', icon: 'temp' }
    }, {
      path: 'tempWaitUploadImage',
      name: 'tempWaitUploadImage',
      component: () => import('@/views/pms/product/tempWaitUploadImage'),
      meta: { title: '临时待上图商品', icon: 'temp' }
    },
    {
      path: 'tempWaitUploadImageEdit',
      name: 'tempWaitUploadImageEdit',
      component: () => import('@/views/pms/product/tempWaitUploadImageEdit'),
      meta: { title: '临时待上图商品编辑' },
      hidden: true
    },
    {
      path: 'waitingReplaceDiscontinueProductList',
      name: 'waitingReplaceDiscontinueProductList',
      component: () => import('@/views/pms/product/waitingReplaceDiscontinueProductList'),
      meta: { title: '待替换产品列表', icon: 'replace' },
    },
    {
      path: 'workCompletedList',
      name: 'workCompletedList',
      component: () => import('@/views/pms/product/workCompletedList'),
      meta: { title: '商品工作记录', icon: 'work-completed' }
    },
    {
      path: 'checkProductToDo',
      name: 'checkProductToDo',
      component: () => import('@/views/pms/check/index'),
      meta: { title: '产品检测ToDoList', icon: 'checkProduct' }
    }
      ,
    {
      path: 'priceExceptionList',
      name: 'priceExceptionList',
      component: () => import('@/views/pms/record/priceExceptionList'),
      meta: { title: '价格变动异常', icon: 'checkProduct' }
    },
    {
      path: 'changePricePushFailed',
      name: 'changePricePushFailed',
      component: () => import('@/views/pms/record/changePricePushFailedList'),
      meta: { title: '价格更新失败', icon: 'failed' },
      hidden: true
    }
      ,
    {
      path: 'autoPriceCutList',
      name: 'autoPriceCutList',
      component: () => import('@/views/pms/record/autoPriceCutList'),
      meta: { title: '自动降价记录' }
    },
    {
      path: 'addProductSupplier',
      name: 'addProductSupplier',
      component: () => import('@/views/pms/product/productSupplier/add'),
      meta: { title: '新增商品供应商' },
      hidden: true
    },
    {
      path: 'updateProductSupplier',
      name: 'updateProductSupplier',
      component: () => import('@/views/pms/product/productSupplier/update'),
      meta: { title: '编辑商品供应商' },
      hidden: true
    },
    {
      path: 'ebaySearchMarketList',
      name: 'ebaySearchMarketList',
      component: () => import('@/views/pms/ebay/ebaySearchMarketList'),
      meta: { title: '搜索Ebay市场产品' },
      hidden: true
    }
    ]
  },
  //采购管理
  {
    path: '/purchasems',
    component: Layout,
    redirect: '/purchasems/require',
    name: 'purchasems',
    meta: { title: '采购', icon: 'purchase' },
    children: [{
      path: 'require',
      name: 'require',
      component: () => import('@/views/purchasems/require/index'),
      meta: { title: '采购需求列表', icon: 'product-list' }
    },
    {
      path: 'createPurchaseOrder',
      name: 'createPurchaseOrder',
      component: () => import('@/views/purchasems/require/createPurchaseOrder'),
      meta: { title: '生成采购订单' },
      hidden: true
    },
    {
      path: 'purchase',
      name: 'purchase',
      component: () => import('@/views/purchasems/purchase/index'),
      meta: { title: '采购订单列表', icon: 'product-list' }
    },
    {
      path: 'shippintItem',
      name: 'shippintItem',
      component: () => import('@/views/purchasems/shipping/index'),
      meta: { title: 'OTTOSHIPPING', icon: 'product-list' }
    },
    {
      path: 'unpack',
      name: 'unpack',
      component: () => import('@/views/purchasems/report/unpackList'),
      meta: { title: '待发货列表', icon: 'product-list' }
    },
    {
      path: 'shipped',
      name: 'shipped',
      component: () => import('@/views/purchasems/report/shippedList'),
      meta: { title: '已发货列表', icon: 'product-list' }
    },
    {
      path: 'productCostDecision',
      name: 'productCostDecision',
      component: () => import('@/views/purchasems/purchase/productCostDecision'),
      meta: { title: '产品决策列表', icon: 'decision' }
    },
    {
      path: 'salesPriceHighList',
      name: 'salesPriceHighList',
      component: () => import('@/views/purchasems/statistic/salesPriceHighList'),
      meta: { title: '产品售价过高列表', icon: 'priceHigh' }
    }
      ,
    {
      path: 'recommendBatchPurchaseList',
      name: 'recommendBatchPurchaseList',
      component: () => import('@/views/purchasems/statistic/recommendBatchPurchaseList'),
      meta: { title: '建议谈价列表', icon: 'talking' }
    },
    {
      path: 'newSalesPriceImportExcel',
      name: 'newSalesPriceImportExcel',
      component: () => import('@/views/purchasems/excel/newSalesPriceImportExcel'),
      meta: { title: '导入销售价格', icon: 'importExcel' }
    },
    {
      path: 'saleRateVolumeList',
      name: 'saleRateVolumeList',
      component: () => import('@/views/purchasems/statistic/saleRateVolumeList'),
      meta: { title: '销售率体积统计', icon: 'product-list' }
    }
    ]
  }
  ,
  //库存管理
  {
    path: '/stockms',
    component: Layout,
    redirect: '/stockms/stock',
    name: 'stockms',
    meta: { title: '库存', icon: 'stock' },
    children: [{
      path: 'receive',
      name: 'receive',
      // component: () => import('@/views/stockms/receive/index'),
      component: () => import('@/views/stockms/receive/receiveStock'),

      meta: { title: '接收元件', icon: 'stock-in' }
    },
    {
      path: 'stock',
      name: 'stock',
      component: () => import('@/views/stockms/stock/index'),
      meta: { title: '当前库存', icon: 'product-list' }
    },

    {
      path: 'stockHistory',
      name: 'stockHistory',
      component: () => import('@/views/stockms/stock/stockHistory'),
      meta: { title: '库存历史', icon: 'history-record' },
      hidden: true
    },
    {
      path: 'startCheck',
      name: 'startCheck',
      component: () => import('@/views/stockms/check/startCheck'),
      meta: { title: '开始盘点', icon: 'check-stock' }
    },
    {
      path: 'checkList',
      name: 'checkList',
      component: () => import('@/views/stockms/check/index'),
      meta: { title: '盘点记录', icon: 'product-list' }
    }
      ,
    {
      path: 'location',
      name: 'location',
      component: () => import('@/views/stockms/location/index'),
      meta: { title: '库存Location', icon: 'product-list' }
    },
    {
      path: 'stock_log',
      name: 'stock_log',
      component: () => import('@/views/stockms/stock/stock_log'),
      meta: { title: '库存日志', icon: 'log-list' }
    },
    {
      path: 'transferLocation',
      name: 'transferLocation',
      component: () => import('@/views/stockms/check/transferLocation'),
      meta: { title: '转移位置' }
    },
    {
      path: 'checkHistoryList',
      name: 'checkHistoryList',
      component: () => import('@/views/stockms/check/checkHistoryList'),
      meta: { title: 'SKU盘点历史' }
    },
    {
      path: 'myobStock',
      name: 'myobStock',
      component: () => import('@/views/stockms/stock/myobStock'),
      meta: { title: 'MyOb库存对比' }
    }
    ]
  },
  //营销管理
  {
    path: '/ads',
    component: Layout,
    redirect: '/ads/promotionList',
    name: 'ads',
    meta: { title: '营销', icon: 'ads' },
    children: [
      {
        path: 'promotionList',
        name: 'promotionList',
        component: () => import('@/views/ads/index'),
        meta: { title: '推广列表', icon: 'ads' }
      }, {
        path: 'selectProductPromotion',
        name: 'selectProductPromotion',
        component: () => import('@/views/ads/promotion/selectProductPromotion'),
        meta: { title: '编辑促销商品', icon: 'promotion' },
        hidden: true
      },
      {
        path: 'massEmail',
        name: 'massEmail',
        component: () => import('@/views/ads/email/index'),
        meta: { title: '群发邮件', icon: 'Email' }
      }, {
        path: 'massEmailLog',
        name: 'massEmailLog',
        component: () => import('@/views/ads/email/massEmailLog'),
        meta: { title: '群发邮件', icon: 'history-record' },
        hidden: true
      },
      {
        path: 'historySummaryPromotionList',
        name: 'historySummaryPromotionList',
        component: () => import('@/views/ads/promotion/historySummaryPromotionList'),
        meta: { title: '推广历史记录', icon: 'ads' }
      },
      {
        path: 'historySkuPromotionList',
        name: 'historySkuPromotionList',
        component: () => import('@/views/ads/promotion/historySkuPromotionList'),
        meta: { title: 'SKU推广历史记录', icon: 'ads' }
      }
    ]
  },
  //统计汇总
  {
    path: '/summary',
    component: Layout,
    redirect: '/summary/sales',
    name: 'summary',
    meta: { title: '统计汇总', icon: 'purchase' },
    children: [
      {
        path: 'report',
        name: 'report',
        component: () => import('@/views/summary/report/index'),
        meta: { title: '销售报告', icon: 'product-list' }
      },
      {
        path: 'rmacancel',
        name: 'rmacancel',
        component: () => import('@/views/summary/report/rma_cancel'),
        meta: { title: 'RMA&Cancel报告', icon: 'product-list' }
      },
      {
        path: 'sales',
        name: 'sales',
        component: () => import('@/views/summary/sales/index'),
        meta: { title: '销售统计', icon: 'product-list' }
      },
      {
        path: 'skuPriceSaleChart',
        name: 'skuPriceSaleChart',
        component: () => import('@/views/summary/sales/skuPriceSaleChart'),
        meta: { title: 'Sku销售价格数量统计', icon: 'product-list' },
        hidden: true
      },
      {
        path: 'sellRate',
        name: 'sellRate',
        component: () => import('@/views/summary/sellRate/index'),
        meta: { title: '销售率统计', icon: 'product-list' }
      },
      {
        path: 'stockSummary',
        name: 'stockSummary',
        component: () => import('@/views/summary/stock/index'),
        meta: { title: '库存统计', icon: 'product-list' }
      },
      {
        path: 'onlinePriceList',
        name: 'onlinePriceList',
        component: () => import('@/views/summary/product/onlinePriceList'),
        meta: { title: '销售网站价格列表', icon: 'priceList' }
      },
      {
        path: 'halfYearNoSellProductList',
        name: 'halfYearNoSellProductList',
        component: () => import('@/views/summary/product/halfYearNoSellProductList'),
        meta: { title: '半年无销售产品', icon: 'product-list' }
      },
      {
        path: 'systemdDeviceList',
        name: 'systemdDeviceList',
        component: () => import('@/views/summary/system/deviceList'),
        meta: { title: '机房设备监控', icon: 'product-list' }
      },
      {
        path: 'salesStatisticsList',
        name: 'salesStatisticsList',
        component: () => import('@/views/summary/order/salesStatisticsList'),
        meta: { title: '营业额统计', icon: 'sales' }
      },
      {
        path: 'summaryByDay',
        name: 'summaryByDay',
        component: () => import('@/views/summary/order/summaryByDay'),
        meta: { title: '订单日期数量统计', icon: 'sales' }
      },
      {
        path: 'orderStatistic',
        name: 'orderStatistic',
        component: () => import('@/views/summary/order/orderStatistic'),
        meta: { title: '订单成本列表', icon: 'sales' }
      }
    ]
  },
  //TODO
  {
    path: '/toDoList',
    component: Layout,
    redirect: '/toDoList/dropshipping',
    name: 'toDoList',
    meta: { title: 'To Do List', icon: 'purchase' },
    children: [{
      path: 'toDo',
      name: 'toDo',
      component: () => import('@/views/toDoList/toDo/index'),
      meta: { title: 'To Do', icon: 'product-list' }
    },
    {
      path: 'dropshipping',
      name: 'toDropshipping',
      component: () => import('@/views/toDoList/dropshipping/index'),
      meta: { title: 'Drop Shipping', icon: 'product-list' }
    },
    {
      path: 'instock',
      name: 'instock',
      component: () => import('@/views/toDoList/instock/index'),
      meta: { title: 'In Stock', icon: 'product-list' }
    },
    {
      path: 'coreproduct',
      name: 'coreproduct',
      component: () => import('@/views/toDoList/coreproduct/index'),
      meta: { title: 'Core Product', icon: 'product-list' }
    },
    {
      path: 'nosell',
      name: 'nosell',
      component: () => import('@/views/toDoList/nosell/index'),
      meta: { title: 'No Sell', icon: 'product-list' }
    },
    {
      path: 'pricelist',
      name: 'pricelist',
      component: () => import('@/views/toDoList/pricelist/index'),
      meta: { title: '价格调整', icon: 'product-list' }
    },
    {
      path: 'inventory_forecast',
      name: 'inventory_forecast',
      component: () => import('@/views/toDoList/boat/inventory_forecast'),
      meta: { title: '库存预览', icon: 'product-list' }
    },
    {
      path: 'boat',
      name: 'boat',
      component: () => import('@/views/toDoList/boat/index'),
      meta: { title: '船期', icon: 'product-list' }
    },
    {
      path: 'boat_history',
      name: 'boat_history',
      component: () => import('@/views/toDoList/boat/boat_history'),
      meta: { title: '船期历史记录', icon: 'product-list' }
    },
    {
      path: 'time_temp_purchase',
      name: 'time_temp_purchase',
      component: () => import('@/views/toDoList/boat/time_temp_purchase'),
      meta: { title: '时间需求', icon: 'product-list' }
    },
    {
      path: 'temp_purchase',
      name: 'temp_purchase',
      component: () => import('@/views/toDoList/boat/temp_purchase'),
      meta: { title: '临时采购需求', icon: 'product-list' }
    },
    {
      path: 'temp_purchase_history',
      name: 'temp_purchase_history',
      component: () => import('@/views/toDoList/boat/temp_purchase_history'),
      meta: { title: '临时采购需求历史记录', icon: 'product-list' }
    },
    {
      path: 'wholesale_export',
      name: 'wholesale_export',
      component: () => import('@/views/toDoList/wholesale/index'),
      meta: { title: 'Wholesale导出', icon: 'product-list' }
    }
    ]
  },
  //对账系统
  {
    path: '/fms',
    component: Layout,
    redirect: '/fms/finance',
    name: 'fms',
    meta: { title: '对账系统', icon: 'finance' },
    children: [{
      path: 'finance',
      name: 'finance',
      component: () => import('@/views/fms/index'),
      meta: { title: '对账', icon: 'finance' }
    },
    {
      path: 'chinaStatement',
      name: 'chinaStatement',
      component: () => import('@/views/fms/chinaStatement'),
      meta: { title: '采购对账单', icon: 'finance' }
    }, {
      path: 'financeHistory',
      name: 'financeHistory',
      component: () => import('@/views/fms/financeHistory'),
      meta: { title: '对账历史', icon: 'history' }
    }, {
      path: 'setMYOB',
      name: 'setMYOB',
      component: () => import('@/views/fms/setMYOB'),
      meta: { title: '设置MYOB' }
    }, {
      path: 'changeSkuOrderList',
      name: 'changeSkuOrderList',
      component: () => import('@/views/fms/changeSkuOrderList'),
      meta: { title: '更换过SKU订单列表' }
    }
    ]
  },
  //售后
  {
    path: '/ams',
    component: Layout,
    redirect: '/ams/service_list',
    name: 'ams',
    meta: { title: '售后', icon: 'service' },
    children: [{
      path: 'receive_parcel',
      name: 'receive_parcel',
      component: () => import('@/views/ams/receive_parcel'),
      meta: { title: '收取包裹', icon: 'receive_parcel' }
    },
    {
      path: 'service_list',
      name: 'service_list',
      component: () => import('@/views/ams/service_list'),
      meta: { title: '售后列表', icon: 'service' }
    }, {
      path: 'repair_check_list',
      name: 'repair_check_list',
      component: () => import('@/views/ams/repair_check_list'),
      meta: { title: '待维修列表', icon: 'repair' }
    },
    {
      path: 'amsOrderDetail',
      name: 'amsOrderDetail',
      component: () => import('@/views/ams/amsOrderDetail'),
      meta: { title: '订单详情' },
      hidden: true
    },
    {
      path: 'secondary_marketing_list',
      name: 'secondary_marketing_list',
      component: () => import('@/views/ams/secondary_marketing_list'),
      meta: { title: '二手市场列表', icon: 'secondary' }
    }
    ]
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      }
    ]
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/dropShipping',
    name: 'sms',
    meta: { title: '系统设定', icon: 'system-setting' },
    children: [{
      path: 'pushDropShipping',
      name: 'pushDropShipping',
      component: () => import('@/views/sms/pushDropShipping'),
      meta: { title: '推送DropShipping', icon: 'publish-setting' }
    },
    {
      path: 'exchangeRate',
      name: 'exchangeRate',
      component: () => import('@/views/sms/exchangeRate'),
      meta: { title: '设置汇率', icon: 'exchange-rage' }
    }
    ]
  },
  { path: 'unsubscribe', redirect: '/unsubscribe', hidden: true },
  { path: '*', redirect: '/404', hidden: true }

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js